import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import RolesProfile from "../screens/masters/Roles/RolesProfile";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { link: "/roles-list", name: "Roles" },
  { link: "/roles-edit", name: "Roles Profile" }
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <RolesProfile />
    </LayoutContainer>
  </>
);

export default Home;
